const STORAGE_KEY = 'a6tr_mock_mode';

// Bootstrap: read ?mock URL param once, persist to localStorage, strip from URL.
// ?mock=1 (or any value other than "0") enables mock mode; ?mock=0 disables it.
const params = new URLSearchParams(window.location.search);
if (params.has('mock')) {
	if (params.get('mock') !== '0') {
		localStorage.setItem(STORAGE_KEY, '1');
	} else {
		localStorage.removeItem(STORAGE_KEY);
	}
	params.delete('mock');
	const query = params.toString();
	window.history.replaceState(
		null,
		'',
		window.location.pathname +
			(query ? `?${query}` : '') +
			window.location.hash,
	);
}

export function isMockMode(): boolean {
	return localStorage.getItem(STORAGE_KEY) === '1';
}

export function setMockMode(enabled: boolean): void {
	if (enabled) {
		localStorage.setItem(STORAGE_KEY, '1');
	} else {
		localStorage.removeItem(STORAGE_KEY);
	}
}
